import React from "react";
import {decode} from 'html-entities';

const ArticleCard = ({description, title, img, link, buttonText}) => {
  return (
    <div className="article-card-container">
      <div className="article-card" style={img ? {backgroundImage: `url(${img})`} : {backgroundColor: 'black'}}>
        <h3 className="article-card-description">{decode(description)}</h3>
        <h2 className="article-card-title">{decode(title)}</h2>
        {link && <a className="article-card-blue-button" href={link}>{buttonText?.length > 0 ? decode(buttonText) : 'READ MORE'}</a>}
      </div>
    </div>

  )
}

export default ArticleCard;